import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSpring, animated } from "react-spring";
import { Background, ModalContent, CloseModalButton, Form, FormContent, Button, Input, Label, Select } from "./style";
import api from "../../../../services/api";
import Swal from "sweetalert2";

export default function Modal({ showModal, setShowModal, dados, setDados }) {
  const modalRef = useRef();
  const [id, setId] = useState(0);
  const [descricao, setDescricao] = useState("");
  const [tipo, setTipo] = useState("");
  const [vencimento, setVencimento] = useState("");

  const animation = useSpring({
    config: {
      duration: 150,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
  });
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 1000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) setShowModal(!showModal);
    },
    [setShowModal, showModal]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  function clear() {
    setDescricao("");
    setTipo("");
  }

  useEffect(() => {
    if (dados) {
      setId(dados?.id);
      setDescricao(dados?.descricao);
      setTipo(dados?.tipo?.toUpperCase() ?? null);
      setVencimento(dados?.vencimento ? new Date(dados?.vencimento).toISOString().split("T")[0] : "");
    }
  }, [dados]);

  /**
   * Vai servir para gerar o pdf do relatório
   * @param {Previne o evento padrão da função} e
   */
  async function handleSubmit(e) {
    e.preventDefault();
    const data = {
      id: id ?? null,
      descricao,
      tipo: tipo ?? null,
      vencimento,
    };

    try {
      const response = id ? await api.patch(`dev/avisos`, { data }) : await api.post(`dev/avisos`, { data });
      if (response.data.error) {
        return Swal.fire("Atenção!", response.data.error, "warning");
      }
      Swal.fire("Sucesso!", response.data.success, "success");
      Toast.fire({
        icon: "success",
        title: "Cadastrado com sucesso!",
      });
      setShowModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error",
        text: "Não foi possível cadastrar!",
        icon: "error",
        confirmButtonColor: "var(--blue-color)",
      });
    }
    clear();
  }

  return (
    <>
      {showModal ? (
        <Background
          ref={modalRef}
          onClick={(e) => {
            if (modalRef.current === e.target) {
              setShowModal(!showModal);
              clear();
            }
          }}
        >
          <animated.div style={animation}>
            <ModalContent>
              <br />
              <Form onSubmit={handleSubmit}>
                <h3>{dados ? "Atualizar Avisos" : "Cadastrar Avisos"}</h3>
                <FormContent>
                  <Label>Descrição:</Label>
                  <Input type="text" value={descricao} placeholder="Descrição" onChange={(e) => setDescricao(e.target.value)} required />
                  <Label>Perfil:</Label>
                  <Select
                    value={tipo}
                    placeholder="Perfil"
                    onChange={(e) => {
                      setTipo(e.target.value);
                    }}
                  >
                    <option value={null} selected>
                      Todos
                    </option>
                    <option value="DEV">Dev</option>
                    <option value="SEC">Secretaria</option>
                    <option value="DIR">Diretoria</option>
                    <option value="RH">RH</option>
                    <option value="COORD">Coordenador</option>
                  </Select>
                  <Label>Vencimento:</Label>
                  <Input type="date" value={vencimento} placeholder="Vencimento" onChange={(e) => setVencimento(e.target.value)} required />
                </FormContent>
                <br />
                <Button type="submit">{id ? "Atualizar" : "Cadastrar"}</Button>
              </Form>
              <CloseModalButton
                onClick={() => {
                  setShowModal(!showModal);
                  clear();
                }}
              />
            </ModalContent>
          </animated.div>
        </Background>
      ) : null}
    </>
  );
}
